<template>
  <div class="container">
    <YuanHengLabelDialog
      factoryName="元亨"
      :visible.sync="yuanHengLabelDialogVisible"
    />
    <QiangLiJuCaiLabelDialog
      factoryName="强力巨彩"
      :visible.sync="qiangLiJuCaiLabelDialogVisible"
    />
    <QiangLiJuCaiLabelV2Dialog
      factoryName="强力巨彩V2"
      :visible.sync="qiangLiJuCaiLabelV2DialogVisible"
    />
    <LiYaDeLabelDialog
      factoryName="利亚德"
      :visible.sync="liYaDeLabelDialogVisible"
    />
    <YiShiDaLabelDialog
      factoryName="易事达"
      :visible.sync="yiShiDaLabelDialogVisible"
    />
    <BaKeLabelDialog
      factoryName="巴科"
      labelName="baKe"
      :visible.sync="baKeLabelDialogVisible"
    />
    <LeiManLabelDialog
      factoryName="惠州雷曼"
      labelName="leiMan"
      :visible.sync="leiManLabelDialogVisible"
    />
    <MeiKaLeLabelDialog
      factoryName="美卡乐"
      labelName="baKe"
      :visible.sync="meiKaLeLabelDialogVisible"
    />
    <JianHeLabelDialog
      factoryName="惠州健和"
      :visible.sync="JianHeLabelDialogVisible"
    />
    <JinLiXiangLabelDialog
      factoryName="金立翔"
      :visible.sync="jinLiXiangLabelDialogVisible"
    />
    <ShiXinLabelDialog
      factoryName="视芯(重打)"
      :visible.sync="shiXinLabelDialogVisible"
    />
    <QiangLiBoxLabelDialog
      factoryName="强力外箱加贴"
      :visible.sync="qiangLiBoxLabelDialogVisible"
    />
    <LianJianLabelDialog
      factoryName="惠州联建"
      :visible.sync="lianjianBoxLabelDialogVisible"
    />
    <WaferLabelDialog
      factoryName="晶圆袋"
      :visible.sync="waferLabelDialogVisible"
    />
    <BoxLabelDialog
      factoryName="晶圆角"
      :visible.sync="boxLabelDialogVisible"
    />
    <WaferBoxLabelDialog
      factoryName="晶圆箱"
      :visible.sync="waferBoxLabelDialogVisible"
    />
    <BagLabelDialog
      factoryName="袋上的标签/B袋"
      :visible.sync="bagLabelDialogVisible"
    />
    <MembraneLabelLabelDialog 
      factoryName="蓝膜上的"
      :visible.sync="membraneLabelDialogVisible"
    />
    <CaseLabelDialog
      factoryName="箱上的"
      :visible.sync="caseLabelDialogVisible"
    />
    <BagLabelCDialog
      factoryName="袋上的标签模板/C袋"
      :visible.sync="bagLabelCDialogVisible"
    />
    <ModuleNoLabelDialog 
      factoryName="模块编号标签"
      :visible.sync="moduleNoDialogVisible"
    />
    <ShiXinLabelV2Dialog 
      factoryName="视芯标签升级"
      :visible.sync="shiXinLabelV2DialogVisible"
    />
    <HuaLanLabelDialog 
      factoryName="花蓝"
      :visible.sync="huaLanLabelDialogVisible"
    />
    <JingTaiLabelDialog 
      factoryName="晶台"
      :visible.sync="jingTaiLabelDialogVisible"
    />
    <el-row :gutter="8">
      <el-col v-for="item in templateData" :key="item.labelType" :xs="24" :sm="12" :lg="8">
        <div class="box-card-container">
          <el-card class="box-card">
            <div slot="header">
              <span class="box-card-title-text">{{ item.title }}标签模板</span>
              <el-button style="float: right; padding: 3px 0" type="text" @click="customizePrint(item.labelType)">
                自定义打印
              </el-button>
            </div>
            <iframe
              :id="item.id"
              :scrolling="item.scrolling"
              width="100%"
              height="260"
              frameborder="0"
              style="background: #E9E9E9; display: inline;cursor: pointer;"
            ></iframe>
          </el-card>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {
  initYuanHengLabelFrame,
  initQiangLiJuCaiLabelFrame,
  initQiangLiJuCaiLabelV2Frame,
  initLiYaDeLabelFrame,
  initBaKeLabelFrame,
  initLeiManLabelFrame,
  initMeiKaLeLabelFrame,
  initYiShiDaLabelFrame,
  initJianHeLabelFrame,
  initJinLiXiangLabelFrame,
  initShiXinLabelFrame,
  initQiangLiBoxLabelFrame,
  initLianJianLabelFrame,
  initWaferLabelFrame,
  initBoxLabelFrame,
  initWaferBoxLabelFrame,
  initBagLabelFrame,
  initMembraneLabelFrame,
  initCaseLabelFrame,
  initBagLabelCFrame,
  initModuleNoLabelFrame,
  initShiXinLabelV2Frame,
  initHuaLanLabelFrame,
  initJingTaiLabelFrame,
} from '@/utils/factory-label';
import YuanHengLabelDialog from './components/YuanHengLabelDialog';
import QiangLiJuCaiLabelDialog from './components/QiangLiJuCaiLabelDialog';
import QiangLiJuCaiLabelV2Dialog from './components/QiangLiJuCaiLabelV2Dialog';
import LiYaDeLabelDialog from './components/LiYaDeLabelDialog';
import YiShiDaLabelDialog from './components/YiShiDaLabelDialog';
import commonLabelDialog from './components/commonLabelDialog';
import JianHeLabelDialog from './components/JianHeLabelDialog';
import JinLiXiangLabelDialog from './components/JinLiXiangLabelDialog';
import ShiXinLabelDialog from './components/ShiXinLabelDialog';
import QiangLiBoxLabelDialog from './components/QiangLiBoxLabelDialog';
import LianJianLabelDialog from './components/LianJianLabelDialog';
import BoxLabelDialog from './components/BoxLabelDialog';
import WaferLabelDialog from './components/WaferLabelDialog';
import WaferBoxLabelDialog from './components/WaferBoxLabelDialog';
import BagLabelDialog from './components/BagLabelDialog';
import MembraneLabelLabelDialog from './components/MembraneLabelLabelDialog';
import CaseLabelDialog from './components/CaseLabelDialog';
import BagLabelCDialog from './components/BagLabelCDialog';
import ModuleNoLabelDialog from './components/ModuleNoLabelDialog';
import ShiXinLabelV2Dialog from './components/ShiXinLabelV2Dialog';
import HuaLanLabelDialog from './components/HuaLanLabelDialog';
import JingTaiLabelDialog from './components/JingTaiLabelDialog';
import {
  definedLabelType,
} from '@/utils/defines';

export default {
  name: "FactoryLabelTemplate",
  components: {
    YuanHengLabelDialog,
    QiangLiJuCaiLabelDialog,
    QiangLiJuCaiLabelV2Dialog,
    LiYaDeLabelDialog,
    YiShiDaLabelDialog,
    BaKeLabelDialog: commonLabelDialog,
    LeiManLabelDialog: commonLabelDialog,
    MeiKaLeLabelDialog: commonLabelDialog,
    JianHeLabelDialog,
    JinLiXiangLabelDialog,
    ShiXinLabelDialog,
    QiangLiBoxLabelDialog,
    LianJianLabelDialog,
    BoxLabelDialog,
    WaferLabelDialog,
    WaferBoxLabelDialog,
    BagLabelDialog,
    MembraneLabelLabelDialog,
    CaseLabelDialog,
    BagLabelCDialog,
    ModuleNoLabelDialog,
    ShiXinLabelV2Dialog,
    HuaLanLabelDialog,
    JingTaiLabelDialog,
  },
  data() {
    const templateData = [{
      labelType: definedLabelType.yuanheng.val,
      title: definedLabelType.yuanheng.chinese,
      id: 'labelIFrameYuanHeng',
      scrolling: 'auto',
    }, {
      labelType: definedLabelType.qiangli.val,
      title: definedLabelType.qiangli.chinese,
      id: 'labelIFrameQiangLiJuCai',
      scrolling: 'auto',
    }, {
      labelType: definedLabelType.qiangli_v2.val,
      title: definedLabelType.qiangli_v2.chinese,
      id: 'labelIFrameQiangLiJuCaiV2',
      scrolling: 'auto',
    }, {
      labelType: definedLabelType.qiangli_box.val,
      title: definedLabelType.qiangli_box.chinese,
      id: 'labelIFrameQiangliBox',
      scrolling: 'no',
    }, {
      labelType: definedLabelType.liyade.val,
      title: definedLabelType.liyade.chinese,
      id: 'labelIFrameLiYaDeLabel',
      scrolling: 'auto',
    }, {
      labelType: definedLabelType.yishida.val,
      title: definedLabelType.yishida.chinese,
      id: 'labelIFrameYiShiDa',
      scrolling: 'auto',
    }, {
      labelType: definedLabelType.bake.val,
      title: definedLabelType.bake.chinese,
      id: 'labelIFrameBaKe',
      scrolling: 'auto',
    }, {
      labelType: definedLabelType.leiman.val,
      title: definedLabelType.leiman.chinese,
      id: 'labelIFrameLeiMan',
      scrolling: 'no',
    }, {
      labelType: definedLabelType.meikale.val,
      title: definedLabelType.meikale.chinese,
      id: 'labelIFrameMeiKaLe',
      scrolling: 'no',
    }, {
      labelType: definedLabelType.jianhe.val,
      title: definedLabelType.jianhe.chinese,
      id: 'labelIFrameJianHe',
      scrolling: 'auto',
    }, {
      labelType: definedLabelType.jinlixiang.val,
      title: definedLabelType.jinlixiang.chinese,
      id: 'labelIFrameJinLiXiang',
      scrolling: 'auto',
    }, {
      labelType: definedLabelType.shixin2.val,
      title: definedLabelType.shixin2.chinese,
      id: 'labelIFrameShiXin',
      scrolling: 'no',
    }, {
      labelType: definedLabelType.lianjian.val,
      title: definedLabelType.lianjian.chinese,
      id: 'labelIFrameLianJian',
      scrolling: 'auto',
    }, {
      labelType: definedLabelType.jingyuan_dai.val,
      title: '晶圆袋',
      id: 'labelIFrameWafer',
      scrolling: 'auto',
    }, {
      labelType: definedLabelType.jingyuan_pian.val,
      title: '晶圆角',
      id: 'labelIFrameBox',
      scrolling: 'auto',
    }, {
      labelType: definedLabelType.jingyuan_box.val,
      title: '晶圆箱',
      id: 'labelIFrameWaferBox',
      scrolling: 'auto',
    }, {
      labelType: definedLabelType.bag.val,
      title: '袋上的标签/B袋',
      id: 'labelIFrameBag',
      scrolling: 'auto',
    }, {
      labelType: definedLabelType.membrane.val,
      title: '蓝膜上的',
      id: 'labelIFrameMembrane',
      scrolling: 'auto',
    }, {
      labelType: definedLabelType.case.val,
      title: '箱上的',
      id: 'labelIFrameCase',
      scrolling: 'auto',
    }, {
      labelType: definedLabelType.bagC.val,
      title: '袋上的标签/C袋',
      id: 'labelIFrameBagC',
      scrolling: 'auto',
    }, {
      labelType: definedLabelType.moduleNo.val,
      title: '模块编号',
      id: 'labelIFrameModuleNo',
      scrolling: 'auto',
    }, {
      labelType: definedLabelType.shixinV2.val,
      title: '视芯标签升级',
      id: 'labelIFrameShiXinV2',
      scrolling: 'auto',
    }, {
      labelType: definedLabelType.hualan.val,
      title: '花蓝',
      id: 'labelIFrameHuaLan',
      scrolling: 'auto',
    }, {
      labelType: definedLabelType.jingtai.val,
      title: '晶台',
      id: 'labelIFrameJingTai',
      scrolling: 'auto',
    }];
    return {
      yuanHengLabelDialogVisible: false,
      qiangLiJuCaiLabelDialogVisible: false,
      qiangLiJuCaiLabelV2DialogVisible: false,
      liYaDeLabelDialogVisible: false,
      yiShiDaLabelDialogVisible: false,
      baKeLabelDialogVisible: false,
      leiManLabelDialogVisible: false,
      meiKaLeLabelDialogVisible: false,
      JianHeLabelDialogVisible: false,
      jinLiXiangLabelDialogVisible: false,
      shiXinLabelDialogVisible: false,
      qiangLiBoxLabelDialogVisible: false,
      lianjianBoxLabelDialogVisible: false,
      boxLabelDialogVisible: false,
      waferLabelDialogVisible: false,
      waferBoxLabelDialogVisible: false,
      bagLabelDialogVisible: false,
      membraneLabelDialogVisible: false,
      caseLabelDialogVisible: false,
      bagLabelCDialogVisible: false,
      moduleNoDialogVisible: false,
      shiXinLabelV2DialogVisible: false,
      huaLanLabelDialogVisible: false,
      jingTaiLabelDialogVisible: false,
      templateData,
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      setTimeout(() => {
        vm.initYuanHengLabelFrame();
        vm.initQiangLiJuCaiLabelFrame();
        vm.initQiangLiJuCaiLabelV2Frame();
        vm.initLiYaDeLabelFrame();
        vm.initBaKeLabelFrame();
        vm.initLeiManLabelFrame();
        vm.initMeiKaLeLabelFrame();
        vm.initYiShiDaLabelFrame();
        vm.initJianHeLabelFrame();
        vm.initJinLiXiangLabelFrame();
        vm.initShiXinLabelFrame();
        vm.initQiangLiBoxLabelFrame();
        vm.initLianJianLabelFrame();
        vm.initWaferLabelFrame();
        vm.initBoxLabelFrame();
        vm.initWaferBoxLabelFrame();
        vm.initBagLabelFrame();
        vm.initMembraneLabelFrame();
        vm.initCaseLabelFrame();
        vm.initBagLabelCFrame();
        vm.initModuleNoLabelFrame();
        vm.initShiXinLabelV2Frame();
        vm.initHuaLanLabelFrame();
        vm.initJingTaiLabelFrame();
      }, 500);
    });
  },
  methods: {
    initYuanHengLabelFrame() {
      let iframe = document.getElementById('labelIFrameYuanHeng');
      iframe = initYuanHengLabelFrame({
        iframe,
        processingOrderNo: 'YHD193289-193291',
        purchaseOrderNo: 'PDDRD084142/1',
        materialNo: '1.08.01.00153',
        specificationNo: 'LS9929STR/SSOP24',
        deliveryDate: '2020-09-15',
        count: 3500,
        boxNo: '#001'
      });
      iframe.contentWindow.document.close();
    },
    initQiangLiJuCaiLabelFrame() {
      let iframe = document.getElementById('labelIFrameQiangLiJuCai');
      iframe = initQiangLiJuCaiLabelFrame({
        iframe,
        partNo: 'LS9929STR',
        materialNo: '10102243',
        orderNo: '0000082253',
        count: 25000,
        weight: 12.65,
        deliveryDate: '2018-05-12',
        batchNo: 'IC561805001'
      });
      iframe.contentWindow.document.close();
    },
    initQiangLiJuCaiLabelV2Frame() {
      let iframe = document.getElementById('labelIFrameQiangLiJuCaiV2');
      iframe = initQiangLiJuCaiLabelV2Frame({
        iframe,
        machineHandNo: '行驱动芯片',
        partNo: 'LS9929S SSOP24 卷装',
        materialNo: '10102243',
        count: 25000,
        deliveryDate: '2018-05-12',
        trackingNo: 'IC56-1805-001'
      });
      iframe.contentWindow.document.close();
    },
    initLiYaDeLabelFrame() {
      let iframe = document.getElementById('labelIFrameLiYaDeLabel');
      iframe = initLiYaDeLabelFrame({
        iframe,
        orderNo: '4100054030',
        materialNo: '10058CD240R70',
        materialDescription: 'LYD6168A',
        count: 32500,
        deliveryDate: '2020-07-15',
        productionBatch: 'FL7T068',
      });
      iframe.contentWindow.document.close();
    },
    initBaKeLabelFrame() {
      let iframe = document.getElementById('labelIFrameBaKe');
      iframe = initBaKeLabelFrame({
        iframe,
        partNo: 'LS9960STR',
        lotNo: 'FL7T06B/FL7U02B',
        qty: 25000,
        trackingNo: 'FL7T06B/FL7U06B/F01',
        dateCode: '2017-08-14',
        packageType: 'SSOP-24-225-0.635',
        result: 'PASSED',
        marking: 'LS9960S',
        grossWeight: '03.00',
        netWeight: '15.63',
        binLevelExplain: 'A',
        customerMaterialNo: '103004SS0008',
      });
      iframe.contentWindow.document.close();
    },
    initLeiManLabelFrame() {
      let iframe = document.getElementById('labelIFrameLeiMan');
      iframe = initLeiManLabelFrame({
        iframe,
        partNo: 'LS9960STR',
        lotNo: 'FL7T06B/FL7U02B',
        qty: 25000,
        trackingNo: 'FL7T06B/FL7U06B/F01',
        dateCode: '2017-08-14',
        packageType: 'SSOP-24-225-0.635',
        result: 'PASSED',
        marking: 'LS9960S',
        grossWeight: '03.00',
        netWeight: '15.63',
        binLevelExplain: 'A',
        customerMaterialNo: '103004SS0008',
      });
      iframe.contentWindow.document.close();
    },
    initMeiKaLeLabelFrame() {
      let iframe = document.getElementById('labelIFrameMeiKaLe');
      iframe = initMeiKaLeLabelFrame({
        iframe,
        partNo: 'LS9960STR',
        lotNo: 'FL7T06B/FL7U02B',
        qty: 25000,
        trackingNo: 'FL7T06B/FL7U06B/F01',
        dateCode: '2017-08-14',
        packageType: 'SSOP-24-225-0.635',
        result: 'PASSED',
        marking: 'LS9960S',
        grossWeight: '03.00',
        netWeight: '15.63',
        binLevelExplain: 'A',
        customerMaterialNo: '103004SS0008',
      });
      iframe.contentWindow.document.close();
    },
    initYiShiDaLabelFrame() {
      let iframe = document.getElementById('labelIFrameYiShiDa');
      iframe = initYiShiDaLabelFrame({
        iframe,
        orderNo: 'ESDPMP17100190',
        customerMaterialNo: '302180010073',
        count: 25000,
      });
      iframe.contentWindow.document.close();
    },
    initJianHeLabelFrame() {
      let iframe = document.getElementById('labelIFrameJianHe');
      iframe = initJianHeLabelFrame({
        iframe,
        materialNo: '20300-0632',
        materialName: 'LS9929S',
        contractNo: 'H221-18120240',
        deliveryDate: '2018/09/07',
      });
      iframe.contentWindow.document.close();
    },
    initJinLiXiangLabelFrame() {
      let iframe = document.getElementById('labelIFrameJinLiXiang');
      iframe = initJinLiXiangLabelFrame({
        iframe,
        orderNo: '4100106429',
        materialNo: 'JX301022320000',
        materialDescription: 'LS9929STR',
        count: 35000,
        deliveryDate: '2019-11-01',
        productionBatch: 'TL9U08C',
      });
      iframe.contentWindow.document.close();
    },
    initShiXinLabelFrame() {
      let iframe = document.getElementById('labelIFrameShiXin');
      iframe = initShiXinLabelFrame({
        iframe,
        partNo: 'LS9929S',
        lotNo: 'YZH',
        qty: 25000,
        trackingNo: 'YZH#01A600',
        dateCode: '2017-08-14',
        packageType: 'SSOP-24-225-0.635',
        result: 'PASSED',
        marking: 'LS9929S',
        grossWeight: '03.00',
        netWeight: '15.63',
        binLevelExplain: 'A',
      });
      iframe.contentWindow.document.close();
    },
    initQiangLiBoxLabelFrame() {
      let iframe = document.getElementById('labelIFrameQiangliBox');
      iframe = initQiangLiBoxLabelFrame({
        iframe,
        partNo: 'LS9929S SSOP24 卷装',
        lotNo: 'YZH-3',
        trackingNo: 'IC56-1805-001',
        reserveInfo: [{
          lotNo: 'YZH',
          cnt: 4000,
        }, {
          lotNo: 'YZHA',
          cnt: 2600,
        }, {
          lotNo: 'YZHB',
          cnt: 2500,
        }]
      });
      iframe.contentWindow.document.close();
    },
    initLianJianLabelFrame() {
      let iframe = document.getElementById('labelIFrameLianJian');
      iframe = initLianJianLabelFrame({
        iframe,
        materialNo: '20300-0632',
        materialName: 'LS9929S',
        contractNo: 'H221-18120240',
        deliveryDate: '2018/09/07',
      });
      iframe.contentWindow.document.close();
    },
    initWaferLabelFrame() {
      let iframe = document.getElementById('labelIFrameWafer');
      iframe = initWaferLabelFrame({
        iframe,
        partNo: 'LS9005X',
        lotNo: 'HPA573#003#1',
        waferCount: 1,
        waferNo: '1-1',
        prop: 'Y',
        dateCode: '2024/2/29',
        qty: 15000,
        trackingNo: 'KAD1067#01#1,2,4',
        binLevelExplain: 'A',
      });
      iframe.contentWindow.document.close();
    },
    initBoxLabelFrame() {
      let iframe = document.getElementById('labelIFrameBox');
      iframe = initBoxLabelFrame({
        iframe,
        partNo: 'LS9005X',
        lotNo: 'HPA573#003#1',
        waferNo: '1-1',
        qty: 1500,
        binLevelExplain: 'A',
      });
      iframe.contentWindow.document.close();
    },
    initWaferBoxLabelFrame() {
      let iframe = document.getElementById('labelIFrameWaferBox');
      iframe = initWaferBoxLabelFrame({
        iframe,
        partNo: 'LS9005X',
        lotNo: 'HPA573#003#1',
        waferCount: 1,
        dateCode: '2024/2/29',
        qty: 1500,
        trackingNo: 'KAD1067#01#1,2,4',
        binLevelExplain: 'A',
      });
      iframe.contentWindow.document.close();
    },
    initBagLabelFrame() {
      let iframe = document.getElementById('labelIFrameBag');
      iframe = initBagLabelFrame({
        iframe,
        partNo: 'LS9005X',
        lotNo: 'KAD1067/KAD111',
        qty: 30000,
        waferNo: '01,02,03,04,05',
        type: 'DIE',
        note: 'A-B',
        dateCode: '2024/2/29',
        binLevelExplain: 'A',
      });
      iframe.contentWindow.document.close();
    },
    initMembraneLabelFrame() {
      let iframe = document.getElementById('labelIFrameMembrane');
      iframe = initMembraneLabelFrame({
        iframe,
        partNo: 'LS9005X',
        lotNo: 'HPA573#003#1',
        waferNo: '1-1',
        qty: 1500,
        binLevelExplain: 'A',
      });
      iframe.contentWindow.document.close();
    },
    initCaseLabelFrame() {
      let iframe = document.getElementById('labelIFrameCase');
      iframe = initCaseLabelFrame({
        iframe,
        partNo: 'LS9005X',
        lotNo: 'KAD1067/KAD111',
        qty: 30000,
        waferNo: '01,02,03,04,05',
        type: 'DIE',
        note: 'A-B',
        dateCode: '2024/2/29',
        binLevelExplain: 'A',
      });
      iframe.contentWindow.document.close();
    },
    initBagLabelCFrame() {
      let iframe = document.getElementById('labelIFrameBagC');
      iframe = initBagLabelCFrame({
        iframe,
        partNo: 'LS9005X',
        lotNo: 'KAD1067/KAD111',
        qty: 30000,
        waferNo: '01,02,03,04,05',
        type: 'DIE',
        note: 'A-B',
        dateCode: '2024/2/29',
        binLevelExplain: 'A',
      });
      iframe.contentWindow.document.close();
    },
    initModuleNoLabelFrame() {
      let iframe = document.getElementById('labelIFrameModuleNo');
      iframe = initModuleNoLabelFrame({
        iframe,
        moduleNo: 'MC1075_2006',
        moduleNoQrCode: 'LC1000MC10752003',
        moduleNo1: 'MC1075_2007',
        moduleNoQrCode1: 'LC1000MC10752004',
      });
      iframe.contentWindow.document.close();
    },
    initShiXinLabelV2Frame() {
      let iframe = document.getElementById('labelIFrameShiXinV2');
      iframe = initShiXinLabelV2Frame({
        iframe,
        partNo: 'LS9929S',
        lotNo: 'YZH',
        qty: 25000,
        trackingNo: 'YZH#01A600',
        dateCode: '2017-08-14',
        packageType: 'SSOP-24-225-0.635',
        result: 'PASSED',
        marking: 'LS9929S',
        grossWeight: '03.00',
        netWeight: '15.63',
        binLevelExplain: 'A',
      });
      iframe.contentWindow.document.close();
    },
    initHuaLanLabelFrame() {
      let iframe = document.getElementById('labelIFrameHuaLan');
      iframe = initHuaLanLabelFrame({
        iframe,
        partNo: 'B4402B',
        lotNo: 'HPE264.04',
        qty: '1',
        waferNo: '9',
        note: '',
        prop: 'Y',
        type: '',
        dateCode: '2026-03-06',
        cn: '',
        die: '58880',
      });
      iframe.contentWindow.document.close();
    },
    initJingTaiLabelFrame() {
      let iframe = document.getElementById('labelIFrameJingTai');
      iframe = initJingTaiLabelFrame({
        iframe,
        supplierCode: 'S.03387',
        materialCode: '10101.00245',
        materialName: 'LS9025Y',
        specModel: '全彩单像素LED显示屏恒流驱动芯片',
        qty: 1000,
        orderNo: 'FP0260300231',
        dateCode: '2026-3-19',
      });
      iframe.contentWindow.document.close();
    },
    customizePrint(labelType) {
      switch (labelType) {
        case definedLabelType.yuanheng.val:
          this.yuanHengLabelDialogVisible = true;
          break;
        case definedLabelType.qiangli.val:
          this.qiangLiJuCaiLabelDialogVisible = true;
          break;
        case definedLabelType.qiangli_v2.val:
          this.qiangLiJuCaiLabelV2DialogVisible = true;
          break;
        case definedLabelType.qiangli_box.val:
          this.qiangLiBoxLabelDialogVisible = true;
          break;
        case definedLabelType.liyade.val:
          this.liYaDeLabelDialogVisible = true;
          break;
        case definedLabelType.yishida.val:
          this.yiShiDaLabelDialogVisible = true;
          break;
        case definedLabelType.bake.val:
          this.baKeLabelDialogVisible = true;
          break;
        case definedLabelType.leiman.val:
          this.leiManLabelDialogVisible = true;
          break;
        case definedLabelType.meikale.val:
          this.meiKaLeLabelDialogVisible = true;
          break;
        case definedLabelType.jianhe.val:
          this.JianHeLabelDialogVisible = true;
          break;
        case definedLabelType.jinlixiang.val:
          this.jinLiXiangLabelDialogVisible = true;
          break;
        case definedLabelType.shixin2.val:
          this.shiXinLabelDialogVisible = true;
          break;
        case definedLabelType.lianjian.val:
          this.lianjianBoxLabelDialogVisible = true;
          break;
        case definedLabelType.jingyuan_dai.val:
          this.waferLabelDialogVisible = true;
          break;
        case definedLabelType.jingyuan_pian.val:
          this.boxLabelDialogVisible = true;
          break;
        case definedLabelType.jingyuan_box.val:
          this.waferBoxLabelDialogVisible = true;
          break;
        case definedLabelType.bag.val:
          this.bagLabelDialogVisible = true;
          break;
        case definedLabelType.membrane.val:
          this.membraneLabelDialogVisible = true;
          break;
        case definedLabelType.case.val:
          this.caseLabelDialogVisible = true;
          break;
        case definedLabelType.bagC.val:
          this.bagLabelCDialogVisible = true;
          break;
        case definedLabelType.moduleNo.val:
          this.moduleNoDialogVisible = true;
          break;
        case definedLabelType.shixinV2.val:
          this.shiXinLabelV2DialogVisible = true;
          break;
        case definedLabelType.hualan.val:
          this.huaLanLabelDialogVisible = true;
          break;
        case definedLabelType.jingtai.val:
          this.jingTaiLabelDialogVisible = true;
          break;   
        default:
          break;
      }
    },
  }
}
</script>

<style scoped>
.container {
  height: 100%;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  padding: 10px 20px;
  box-sizing: border-box;
  flex: 1;
  overflow: auto;
}

.box-card-container {
  padding: 10px;
  box-sizing: border-box;
  transition: transform 0.1s ease-in;
  -webkit-transition: transform 0.1s ease-in;
}

.box-card-container:hover {
  transform: scale(1.05);
  box-shadow: rgba(0, 0, 0, .04);
}

.box-card {
  height: 100%;
}

.box-card-title-text {
  color: #169CD6;
}

/deep/ .el-row {
  width: 100%;
}

/deep/ .el-card__header {
  padding: 10px 15px;
  text-align: center;
}
</style>
